import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of, combineLatest } from 'rxjs';
import { switchMap, catchError, take } from 'rxjs/operators';
import { UserStoreService } from '../user/store/user-store.service';
import { UserService } from '../user/user.service';
import { User } from '../user/user.interfaces';
import { SiteStoreService } from '../site/store/site-store.service';
import { Site } from '../site/site.interfaces';
import { AppRouteService } from '../app-route.service';

@Injectable()
export class AuthenticatedUserService {
  constructor(public auth: AuthService, public router: Router) {}

  canActivate(): boolean {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}

@Injectable()
export class IsAdminService {
  path = window.location.pathname;
  constructor(
    public router: Router,
    private siteStoreService: SiteStoreService,
    private userStoreService: UserStoreService,
    private userService: UserService,
    private appRouteService: AppRouteService
  ) {}

  getFromStoreOrAPI(): Observable<User> {
    return this.userStoreService.user$.pipe(take(1));
  }

  getSite(): Observable<Site> {
    return this.siteStoreService.site$.pipe(take(1));
  }

  canLoad(): Observable<boolean> {
    return combineLatest(this.getFromStoreOrAPI(), this.getSite()).pipe(
      switchMap(([user, site]) => {
        let siteId = '';
        if (site) {
          siteId = site.id;
        } else {
          siteId = this.path.substring(this.path.indexOf('site/') + 5, this.path.indexOf('/admin'));
        }
        if (user && this.userService.userIsAdmin(user, siteId)) {
          return of(true);
        } else {
          this.router.navigate([this.appRouteService.getListRoute(siteId)]);
          return of(false);
        }
      }),
      catchError(error => {
        console.log('Can Load Error: ', error);
        return of(false);
      })
    );
  }
}

@Injectable()
export class NotAuthenticatedService {
  constructor(public auth: AuthService) {}

  canActivate(): boolean {
    if (!this.auth.isAuthenticated()) {
      return true;
    }
    return false;
  }
}
